<div style="position: absolute;top: 0;left: 0;width: 100%;">
  <nav class="navbar navbar-expand navbar-color navbar-light" style="margin-left: 0px;height: 70px; padding-left: 0;">
    <a [routerLink]="['/']">
    <img
        src={{logoUrl}}
        alt="AdminLTE Logo"
        class="brand-image"
        style="margin-left: 20px;"
      /></a>
  </nav>
</div>

<div class="login-box" style="margin-top: 80px;">
  <div class="login-logo">
    <!-- <i class="fas fa-exclamation-triangle circle-icon" style='font-size:30px; color: white'></i> -->
    <img src="assets/img/グループ 40.svg"/>
  </div>
  <div class="login-logo" id="err_title1">
    <p class="reques-class" style="font-size: 20px; color:#F85F58;">{{ 'WARNING.TITLE_1' | translate }}</p>
  </div>
  <div class="text-center" style="margin-top: 40px;" id="err_text1">
    <p class="reques-class" style="font-size: 16px;color: #3E3E3E;">{{ 'WARNING.WARNING_TXT_1' | translate }}<br>{{ 'WARNING.WARNING_TXT_2' | translate }}</p>
  </div>
  <div class="login-logo" style="display: none;font-size: 20px; color:#F85F58;" id="err_title2">
  </div>
  <div class="text-center" style="margin-top: 40px; display: none;font-size: 16px;color: #3E3E3E;" id="err_text2">
  </div>
</div>